import React from "react";
import Navbar from "./components/navbar";
import CreateThaniacelComponent from "./create/create.component";
import CreateThaniacelProvider from "./create/provider/createThaniacel.provider";
import CreateUsedThaniacelProvider from "./create/used/provider/createUsedThaniacel.provider";
import CreateNewsThaniacelProvider from "./create/news/provider/createNewsThaniacel.provider";

const ThaniacelPage = () => {
  return (
    <CreateThaniacelProvider>
      <CreateNewsThaniacelProvider>
        <CreateUsedThaniacelProvider>
          <div className="h-screen overflow-auto bg-gradient-to-b from-white to-[#000]">
            <Navbar />
            <section className="flex h-full w-full items-center justify-center p-0">
              <div className="container mb-auto mt-auto w-full px-4 lg:px-20">
                <CreateThaniacelComponent />
              </div>
            </section>
          </div>
        </CreateUsedThaniacelProvider>
      </CreateNewsThaniacelProvider>
    </CreateThaniacelProvider>
  );
};

export default ThaniacelPage;
